import * as React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import { Col, Tabs, Collapse, message, Row } from 'antd';
import FFBids from './FFBids';
import CreateEnquiryDetails from './CreateEnquiryDetails';
import { connect } from 'react-redux';
import ShipperBids from './ShipperBids';
import Navbar from 'src/components/navbar/Navbar';
import Loader from 'src/components/common/Loader';
import {
  fetchInquiryDetailsForShipper,
  fetchInquiryDetailsForFF,
  fetchInquirySummaryForShipper,
  viewBreakDownForShipper,
  getExchangeRate,
} from 'src/api/inquiry';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import {
  getInquiryCreateBidRoute,
  getInquiryDetailRoute,
  getInquiryFFRoute,
  getInquiryShipperRoute,
} from 'src/routing/utils';
import { getInquiryDetail, setPrevPagination } from 'src/actions/inquiryShipperActions';
import { bindActionCreators } from 'redux';
import BidsSortByModal from './Modals/BidsSortByModal';
import FFBidsFilterModal from './Modals/FFBidsFilterModal';
import { downloadFileData } from 'src/utils/utils';
import {
  setFilter as setFilterShipper,
  applyFilter as applyFilterShipper,
  resetFilters as resetFiltersShipper,
} from 'src/actions/inquiryShipperActionsBids';
import {
  setFilter as setFilterFF,
  applyFilter as applyFilterFF,
  resetFilters as resetFiltersFF,
} from 'src/actions/inquiryFFActionBids';

import { MIN_WIDTH } from 'src/globals';
import { getBidTotal } from './InquiryUtils';

import withInquiryMasterData from './hoc/InitInquiryMaster';
import { isValidArray } from 'src/Library/Helper';
import InquiryRejectedFFModal from './Modals/InquiryRejectedFFModal';
import { InquiryModes, InquiryType } from 'src/Library/Constants';
import { AxiosResponse } from 'axios';
import { ApiResponseWrapper } from 'src/api/apiHandler';
import { tokens } from 'src/design-system';

const TabPane = Tabs.TabPane;
const { Panel } = Collapse;

const COLORS = {
  GREEN: '#52C41A',
  RED: '#F5222D',
  BLUE: tokens.colors.primary,
  GREY: '#595959',
  LIGHTGREY: '#D9D9D9',
};

const styles = (theme) => ({
  tabContainer: {
    '& .ant-tabs-tab': {
      marginBottom: '0 !important',
      textAlign: 'left !important',
    },
    '& .ant-tabs-bar': {
      width: '100% !important',
    },
    '& .ant-tabs-content': {
      width: '0 !important',
    },
    '& .ant-tabs-tab-active': {
      color: COLORS.BLUE,
      fontSize: `${tokens.fontSize.body}px`,
      fontWeight: tokens.fontWeight.semibold,
    },
    '& .ant-tabs-ink-bar': {
      background: COLORS.BLUE,
      width: '4px',
    },
  },
  iconsTheme: {
    '&:hover': {
      color: COLORS.GREEN,
    },
  },
  tab: {
    marginBottom: '0px',
    paddingTop: '4px',
  },
  shadow: {
    border: '1px solid #D9D9D9',
    opacity: '0.5',
    marginLeft: '0px',
  },
  paragraph: {
    fontsize: '11px',
    padding: '9px 9px 0px 24px',
    fontfamily: 'Open Sans',
  },
  anchorTags: {
    fontsize: '11px',
    paddingLeft: '24px',
    paddingTop: '17px',
    fontfamily: 'Open Sans SemiBold',
    color: tokens.colors.primary,
    display: 'block',
    fontWeight: `${tokens.fontWeight.semibold}`,
  },
  row2: {
    '& .ant-row': {
      marginLeft: '5px !important',
      paddingLeft: '0px !important',
    },
  },
  verticalLine: {
    border: '1px solid #D9D9D9',
    height: '37px',
    width: '2px',
  },
  customPanelStyle: {
    minHeight: '40px',
    background: '#f7f7f7',
    borderRadius: tokens.radius.md,
    border: 0,
    overflow: 'hidden',
    '& .ant-collapse-header': {
      display: 'flex',
      color: 'yellow',
    },
    '& .ant-collapse-content-box': {
      background: '#F7F7F7',
    },
  },
  fixedPanel: {
    '& .ant-collapse-header': {
      padding: '0px',
    },
  },
  sidePanelCharges: {
    display: 'flex',
    justifyContent: 'space-between',
    // marginBottom: '8px',
  },
  sidePanelShowBids: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  sidePanelText: {
    fontSize: `${tokens.fontSize.caption}px`,
    paddingRight: '12px',
    background: tokens.colors.bgWhite,
    padding: '12px',
    cursor: 'default',
    borderBottom: '1px solid #d9d9d9',
  },
  viewAllRejected: {
    color: '#1478F6',
    fontSize: `${tokens.fontSize.caption}px`,
    marginTop: '4px',
    cursor: 'pointer',
  },
});

class InquiryDetail extends React.PureComponent<any, any> {
  state: any = {
    newDeadline: null,
    activeKey: '1',
    isLoading: true,
    inquiryData: null,
    ShipperBidsFilterModalVisible: false,
    sendRFQConfirmationVisible: false,
    ShipperBidsSortByModalVisible: false,
    filterModalVisible: false,
    bidsSortByModalVisible: false,
    clearVisible: false,
    iconsLoading: false,
    deleteModalLoading: false,
    isDownloadLoading: false,
    isInquiryDetailLoading: false,
    shouldShipperResetFilter: true,
    isViewAllFFsRejectedVisible: false,
    exchangeRates: {} as any
  };

  loadInquiryData = async () => {
    const { match } = this.props;
    const inquiryId = match.params.inquiryId;
    const tabId = match.params.tabId;
    const bidId = match.params.bidId;
    if (inquiryId && isNaN(+inquiryId)) {
      message.error('Error: Invalid Format of Inquiry ID');
      this.handleBack();
      return;
    }
    tabId === 'details' ? this.setState({ activeKey: '1' }) : this.setState({ activeKey: '2' });
    let response;
    this.setState({
      iconsLoading: true,
    });
    if (this.props.type === 'SHIPPER') {
      response = await fetchInquiryDetailsForShipper({ inquiryId });
    } else {
      response = await fetchInquiryDetailsForFF({ inquiryId });
    }
    if (response.isSuccess && response.data && response.data.id) {
      this.setState({
        inquiryData: response.data,
        newDeadline: response.data.deadline,
      });
    } else {
      message.error(`Error:
        ${response.errorMessage ? response.errorMessage : 'Inquiry does not exist'}
      `);
      this.handleBack();
      return;
    }
    this.setState({
      iconsLoading: false,
      isLoading: false,
    });
    if (bidId) await this.handleShowBid([bidId]);
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.loadInquiryData();
    // await this.fetchExchangeRates();
    if (this.props.type === 'SHIPPER') await this.getSidePanelData();
  }

  // fetchExchangeRates = async () => {
  //   const { userCurrency } = this.props;
  //   const response = await getExchangeRate({
  //     inquiryId: this.state.inquiryData.id,
  //     currentCurrency: 'USD',
  //     finalCurrency: userCurrency,
  //   });
  //   if (response.isSuccess) {
  //     const temp = this.state.exchangeRates;
  //     temp['USD'] = response.data.rate;
  //     this.setState({
  //       exchangeRates: temp,
  //     });
  //   }
  // };

  handleAddBid = (inquiryId) => {
    const { history } = this.props;
    history.push(getInquiryCreateBidRoute(inquiryId), 'fromBids');
  };

  getSidePanelData = async () => {
    const { inquiryData } = this.state;
    if (!inquiryData) return;
    const response = await fetchInquirySummaryForShipper({ inquiryId: inquiryData.id });
    if (response.isSuccess) {
      this.setState({ inquirySummary: response.data?.data });
    } else {
      message.error('Unable to load summary');
    }
  };

  handleShowBid = async (ids) => {
    if (!ids) return;
    const { applyFilterShipper, setFilterShipper, applyFilterFF, setFilterFF } = this.props;
    const { inquiryData } = this.state;
    if (this.props.type === 'SHIPPER') {
      await setFilterShipper({
        bidIdList: ids,
      });
      await applyFilterShipper(inquiryData.id);
    } else {
      await setFilterFF({
        bidIdList: ids,
      });
      await applyFilterFF(inquiryData.id);
    }
    this.handleTabChange('2', false);
  };

  renderSidePanel = () => {
    const { classes, userCurrency, permissions } = this.props;
    const { INQUIRY_CREATE_UPDATE_ACTIONS, INQUIRY_SEND_ACTIONS, INQUIRY_VIEW_BIDS_ACTIONS, INQUIRY_CONFIRM_DECLINE_ACTIONS } = permissions;
    const { inquiryData, inquirySummary, exchangeRates } = this.state;
    const isDomestic = inquiryData.mode === InquiryModes.DOMESTIC;
    const isRPTL = inquiryData.mode === InquiryModes.RPTL;
    if (!inquirySummary) {
      return '';
    }
    const currencySymbol = inquirySummary?.bidSummary?.currency;
    const bidRank1Charges =
      inquirySummary.bidSummary &&
      inquirySummary.bidSummary.rank1Info &&
      Object.keys(inquirySummary.bidSummary.rank1Info).length > 0 ? (
        <div style={{ marginRight: '20px' }}>
          {inquirySummary.bidSummary.rank1Info.freightTotal != null && (
            <div className={classes.sidePanelCharges} style={{ marginBottom: '8px' }}>
              <div style={{ fontSize: '11px', fontWeight: 'normal' }}>
                {isDomestic ? 'Transport Charges' : 'Ocean Freight Charges'}
              </div>
              <div>
                {getBidTotal(inquirySummary.bidSummary.rank1Info.freightTotal)}
                &nbsp;{currencySymbol}
              </div>
            </div>
          )}
          {inquirySummary.bidSummary.rank1Info.originTotal != null && (
            <div className={classes.sidePanelCharges} style={{ marginBottom: '8px' }}>
              <div style={{ fontSize: '11px', fontWeight: 'normal' }}>Origin Charges</div>
              <div>
                {getBidTotal(inquirySummary.bidSummary.rank1Info.originTotal)}
                &nbsp;{currencySymbol}
              </div>
            </div>
          )}
          {inquirySummary.bidSummary.rank1Info.destinationTotal != null && (
            <div className={classes.sidePanelCharges} style={{ marginBottom: '8px' }}>
              <div style={{ fontSize: '11px', fontWeight: 'normal' }}>Destination Charges</div>
              <div>
                {getBidTotal(inquirySummary.bidSummary.rank1Info.destinationTotal)}
                &nbsp;{currencySymbol}
              </div>
            </div>
          )}
        </div>
      ) : null;
    const minOceanFreightCharges = inquirySummary.bidSummary.minFreightInfo &&
      inquirySummary.bidSummary.minFreightInfo.total != null && (
        <div className={classes.sidePanelCharges}>
          <div style={{ fontSize: '11px', fontWeight: 'normal' }}>
            {isDomestic ? 'Transport Charges' : 'Ocean Freight Charges'}
          </div>
          <div className={classes.sidePanelShowBids}>
            <div>
              {getBidTotal(inquirySummary.bidSummary.minFreightInfo.total)}
              &nbsp;{currencySymbol}
            </div>
            <a
              style={{ color: tokens.colors.primary, fontSize: '9px' }}
              onClick={() => this.handleShowBid(inquirySummary.bidSummary.minFreightInfo.ids)}
            >
              Show Bid
            </a>
          </div>
        </div>
      );
    const minOriginCharges = inquirySummary.bidSummary.minOriginInfo &&
      inquirySummary.bidSummary.minOriginInfo.total != null && (
        <div className={classes.sidePanelCharges}>
          <div style={{ fontSize: '11px', fontWeight: 'normal' }}>Origin Charges</div>
          <div className={classes.sidePanelShowBids}>
            <div>
              {getBidTotal(inquirySummary.bidSummary.minOriginInfo.total)}
              &nbsp;{currencySymbol}
            </div>
            <a
              style={{ color: tokens.colors.primary, fontSize: '9px' }}
              onClick={() => this.handleShowBid(inquirySummary.bidSummary.minOriginInfo.ids)}
            >
              Show Bid
            </a>
          </div>
        </div>
      );
    const minDestinationCharges = inquirySummary.bidSummary.minDestinationInfo &&
      inquirySummary.bidSummary.minDestinationInfo.total != null && (
        <div className={classes.sidePanelCharges}>
          <div style={{ fontSize: '11px', fontWeight: 'normal' }}>Destination Charges</div>
          <div className={classes.sidePanelShowBids}>
            <div>
              {getBidTotal(inquirySummary.bidSummary.minDestinationInfo.total)}
              &nbsp;{currencySymbol}
            </div>
            <a
              style={{ color: tokens.colors.primary, fontSize: '9px' }}
              onClick={() => this.handleShowBid(inquirySummary.bidSummary.minDestinationInfo.ids)}
            >
              Show Bid
            </a>
          </div>
        </div>
      );
    const lowestCharges = inquirySummary.bidSummary &&
      (minOceanFreightCharges || minOriginCharges || minDestinationCharges) && (
        <div style={{ marginRight: '20px' }}>
          {minOceanFreightCharges}
          {minOriginCharges}
          {minDestinationCharges}
        </div>
      );
    const ffsRejected = isValidArray(inquirySummary.ffsRejected) ? (
      <React.Fragment>
        <div>{inquirySummary.ffsRejected.map((item) => item.name).join(', ')}</div>
        <div
          className={classes.viewAllRejected}
          onClick={() => this.setState({ isViewAllFFsRejectedVisible: true })}
        >
          View all with Remarks
        </div>
      </React.Fragment>
    ) : (
      'NA'
    );
    const sidePanelData = [
      ...(INQUIRY_SEND_ACTIONS ? [
        {
          key: '1',
          headerTitle: `${(isDomestic || isRPTL)  ? 'Trucker' : 'FFs'} Participating:`,
          headerValue: inquirySummary.sentFfIds.length,
          content: inquirySummary.sentFfIds.map((item) => item.name).join(', '),
        },
        {
          key: '2',
          headerTitle: `${(isDomestic || isRPTL) ? 'Trucker' : 'FFs'} Accepted the Inquiry`,
          headerValue: inquirySummary.respondedFfIds.length,
          content: inquirySummary.respondedFfIds.map((item) => item.name).join(', '),
        },
        {
          key: '3',
          headerTitle: `${(isDomestic || isRPTL)  ? 'Trucker' : 'FFs'} Declined the Inquiry`,
          headerValue: inquirySummary.ffsRejected?.length,
          content: ffsRejected,
        }
      ] : []),
      ...(INQUIRY_VIEW_BIDS_ACTIONS ? [
        {
          key: '4',
          headerTitle: 'Bid Rank 1 Price',
          headerValue:
            inquirySummary.bidSummary.rank1Info && inquirySummary.bidSummary.rank1Info.total
              ? `${getBidTotal(inquirySummary.bidSummary.rank1Info.total)} ${currencySymbol} `
              : '-',
          content: bidRank1Charges,
        },
        {
          key: '5',
          headerTitle: 'Lowest Charges',
          headerValue: '',
          content: lowestCharges,
        }
      ] : []),
    ];
    const text = (
      <p>
        {INQUIRY_CREATE_UPDATE_ACTIONS ? 'Congratulations on successfully creating your inquiry! ' : ''}
        {INQUIRY_SEND_ACTIONS ? 'Start sending the inquiry to your trusted freight forwarders to receive suitable bids. ' : ''} 
        {INQUIRY_CONFIRM_DECLINE_ACTIONS ? 'Compare bid responses to select and confirm the best one. ' : ''}
      </p>
    );
    return (
      <div style={{ padding: '0px 12px 0px 12px' }}>
        <Collapse onChange={() => undefined}>
          {sidePanelData.map((item) => {
            return (
              <Panel
                header={
                  <div style={{ width: '90%', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: `${tokens.fontSize.caption}px` }}>{item.headerTitle}</div>
                    <div
                      style={{
                        fontWeight: 'bold',
                        fontSize: `${tokens.fontSize.small}px`,
                        color: item.key === '4' ? '#F17517' : undefined,
                      }}
                    >
                      {item.headerValue}
                    </div>
                  </div>
                }
                key={item.key}
                style={{ fontSize: `${tokens.fontSize.small}px`, background: tokens.colors.bgWhite }}
                className={classes.customPanelStyle}
              >
                <div
                  style={{
                    fontSize: `${tokens.fontSize.small}px`,
                    color: '#262626',
                    fontWeight: tokens.fontWeight.semibold,
                    marginBottom: 0,
                  }}
                >
                  {item.content || 'NA'}
                </div>
              </Panel>
            );
          })}
          <div className={classes.sidePanelText}>{text}</div>
        </Collapse>
      </div>
    );
  };

  handleTabChange = (activeKey, shouldShipperResetFilter = true) => {
    const { inquiryData } = this.state;
    if (activeKey === '1') {
      this.props.history.push(
        getInquiryDetailRoute(this.props.type.toLowerCase(), inquiryData.id, 'details')
      );
      this.loadInquiryData();
      this.setState({ activeKey, shouldShipperResetFilter });
    } else {
      this.props.history.push(
        getInquiryDetailRoute(this.props.type.toLowerCase(), inquiryData.id, 'bids')
      );
      this.setState({ activeKey, shouldShipperResetFilter });
    }
  };

  handleBack = () => {
    const { history, ffModeList, shipperModeList } = this.props;
    if (this.props.type === 'SHIPPER') {
      this.props.setPrevPagination(false);
      history.push(
        getInquiryShipperRoute(isValidArray(shipperModeList) ? `modeList=${shipperModeList}` : ''),
        { shouldKeepFilters: true }
      );
    } else {
      history.push(getInquiryFFRoute(isValidArray(ffModeList) ? `modeList=${ffModeList}` : ''), {
        shouldKeepFilters: true,
      });
    }
  };

  renderFFsRejectedModal = (): React.ReactElement => {
    const { isViewAllFFsRejectedVisible, inquirySummary } = this.state;
    return (
      <InquiryRejectedFFModal
        visible={isViewAllFFsRejectedVisible}
        handleCancel={() => this.setState({ isViewAllFFsRejectedVisible: false })}
        ffRejectedData={inquirySummary.ffsRejected}
      />
    );
  };

  render() {
    const { classes, permissions } = this.props;
    const { INQUIRY_VIEW_BIDS_ACTIONS } = permissions;
    const { activeKey, isLoading, inquiryData, isViewAllFFsRejectedVisible } = this.state;
    if (isLoading || !inquiryData) {
      return (
        <div style={{ minWidth: MIN_WIDTH, height: '400px', width: '100%' }}>
          <Navbar pageTitle="Inquiry" handleBack={this.handleBack} alwaysShowBack={true} />
          <Loader />
        </div>
      );
    }
    const roadBased = [InquiryModes.TRAILER, InquiryModes.DOMESTIC, InquiryModes.RPTL].includes(inquiryData.mode);
    const originAddress = inquiryData.originLocationDetails?.city || inquiryData.originLocationDetails?.name;
    const allowVendorToSpecifyOrigin = inquiryData.otherDetails?.allowVendorToSpecifyOrigin;
    const originPort = allowVendorToSpecifyOrigin 
      ? inquiryData?.origin?.countryName
      : `${inquiryData.originPortDetails?.name} (${inquiryData.originPortDetails?.code})`;
    const origin = roadBased ? originAddress : originPort;
    const destinationAddress = inquiryData.destinationLocationDetails?.city || inquiryData.destinationLocationDetails?.name;
    const allowVendorToSpecifyDestination = inquiryData.otherDetails?.allowVendorToSpecifyDestination;
    const destinationPort = allowVendorToSpecifyDestination 
      ? inquiryData?.destination?.countryName
      : `${inquiryData.destinationPortDetails?.name} (${inquiryData.destinationPortDetails?.code})`;
    const destination = roadBased ? destinationAddress : destinationPort;
    return (
      <div style={{ minWidth: MIN_WIDTH, height: '100%' }}>
        <Navbar pageTitle="Inquiry" alwaysShowBack handleBack={this.handleBack} />
        <Row style={{ display: 'flex', height: '100%' }}>
          <Col span={5} style={{ backgroundColor: '#FCFCFC' }}>
            <div style={{ marginTop: '16px' }}>
              <div className={classes.tabContainer}>
                <Tabs
                  activeKey={this.state.activeKey}
                  onChange={this.handleTabChange}
                  tabPosition={'left'}
                >
                  <TabPane tab={'Inquiry Details'} key={'1'} />
                  <TabPane tab={'Bids'} key={'2'} disabled={this.props.type === 'SHIPPER' && !INQUIRY_VIEW_BIDS_ACTIONS}/>
                </Tabs>
              </div>
              <div>
                <hr className={classes.shadow}></hr>
              </div>
              <div>
                {this.props.type === 'SHIPPER' ? (
                  this.renderSidePanel()
                ) : (
                  <p className={classes.paragraph} style={{ fontSize: '11px' }}>
                    <strong>
                      {inquiryData.organisationName &&
                        inquiryData.organisationName.toString().concat(' ')}
                    </strong>
                    has sent you an inquiry for <strong>{origin}</strong> -{' '}
                    <strong>{destination}</strong>.<br />
                    Start creating bids and submit your responses before &nbsp;
                    <strong>
                      {(() => {
                       
                        
                        if (this.props.timezone && inquiryData.deadline) {
                          return momentTimezone(inquiryData.deadline).tz(this.props.timezone).format('DD MMM YYYY : HH:mm');
                        } else if (inquiryData.deadline) {
                          return moment(inquiryData.deadline).format('DD MMM YYYY : HH:mm');
                        }
                        return '-- : --';
                      })()}
                    </strong>
                  </p>
                )}
              </div>
            </div>
          </Col>
          <Col span={19} style={{ borderLeft: '1px #D9D9D9 solid', backgroundColor: '#F9F9F9' }}>
            {activeKey === '1' ? (
              <CreateEnquiryDetails
                isLoading={this.state.isInquiryDetailLoading}
                key={this.state.inquiryData.id}
                type={this.props.type}
                data={this.state.inquiryData}
                getSidePanelData={this.getSidePanelData}
              />
            ) : this.props.type === 'SHIPPER' ? (
              <ShipperBids
                exchangeRates={this.state.exchangeRates}
                inquiryData={this.state.inquiryData}
                loadInquiryData={this.loadInquiryData}
                shouldResetFilter={this.state.shouldShipperResetFilter}
              />
            ) : (
              <FFBids loadInquiryData={this.loadInquiryData} inquiryData={this.state.inquiryData} exchangeRates={this.state.exchangeRates}/>
            )}
          </Col>
        </Row>
        {isViewAllFFsRejectedVisible && this.renderFFsRejectedModal()}
      </div>
    );
  }
}
const mapStateToProps = ({
  masterData,
  inquiryShipperBidsReducer,
  inquiryFFBidsReducer,
  inquiryFFReducer,
  inquiryShipperReducer,
}) => {
  return {
    currencySymbols: masterData.currencySymbols,
    ffList: masterData.dimensionData.FF,
    appliedFilters: inquiryShipperBidsReducer.appliedFilters,
    appliedFiltersFF: inquiryFFBidsReducer.appliedFilters,
    paginationFF: inquiryFFBidsReducer.pagination,
    pagination: inquiryShipperBidsReducer.pagination,
    allBidsForInquiry: inquiryShipperBidsReducer.allBidsForInquiry,
    ffModeList: inquiryFFReducer.appliedFilters?.modeList,
    shipperModeList: inquiryShipperReducer.appliedFilters?.modeList,
    userCurrency: masterData?.userData?.user_metadata?.user_currency,
    permissions: masterData.permissions,
    timezone: masterData.timezone,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFilterShipper,
      applyFilterShipper,
      resetFiltersShipper,
      setFilterFF,
      applyFilterFF,
      resetFiltersFF,
      getInquiryDetail,
      setPrevPagination,
    },
    dispatch
  );

const StyledInquiryDetail = injectSheet(styles)(InquiryDetail);
export default withInquiryMasterData(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(StyledInquiryDetail))
);
